import cookie from 'vue-cookie'

import * as types from './mutation-types'

import authApi from '../api/auth'
import cartApi from '../api/cart'
import orderApi from '../api/order'
import companyApi from '../api/company'
import balanceApi from '../api/balance'
import dataApi from '../api/data'

export const init = ({commit, state, dispatch, getters}) => {
  let userId, token
  userId = cookie.get('userId')
  token = cookie.get('token')

  state.auth.isLogin = userId && token
  if (userId && token) {
    window.localStorage.setItem('token', token)
    window.localStorage.setItem('userId', userId)

    // dispatch('getUserInfo')
  } else {
    // this.$message.warning('登录失效')
    // window.location.href = process.env.ACCT_API
  }

  /* global returnCitySN */
  // http://pv.sohu.com/cityjson
  let remoteIpInfo = '' // returnCitySN
  console.log(remoteIpInfo)
  let code = 'SHSH'
  // remoteIpInfo.city = '东莞'
  // remoteIpInfo.province = '广东'
  if (remoteIpInfo) {
    let _pRegion = dataApi.regions
    // .filter(r => r.pName === remoteIpInfo.province)

    if (_pRegion && _pRegion.length > 0) {
      let _region = _pRegion.find(r => remoteIpInfo.cname.indexOf(r.name) >= 0) || _pRegion[0]
      if (_region) {
        code = _region.code
      }
    }
  }
  console.log('%c[actions-init]', 'color: #63ADD1', code)
  dispatch('changeRegion', code)
}

export const changeRegion = async ({state, rootState, commit, dispatch, getters}, code) => {
  /**
   * 获取产品列表
   */
  commit(types.CHANGE_REGION, code)
  // debugger
  await dispatch('fetchProducts', code)
}

export const getUserInfo = ({commit, state}, ignoreErr = false) => {
  return new Promise((resolve, reject) => {
    authApi.getUser(
      data => {
        // debugger
        if (data.type === 'ERROR.NO_AUTH') {
          // window.localStorage.clear()
          // state.auth.isLogin = false
          cookie.del('userId')
          cookie.del('token')
          state.auth.isLogin = false
        } else {
          commit(types.RECEIVE_USER, data)
          // companyApi.fetchCompanies(
          //   data => {
          //     if (data.type !== 'ERROR.NO_AUTH') {
          //       commit(types.INIT_COMPANIES, data)
          //     }
          //   },
          //   err => {
          //     console.log(err)
          //   })
        }
        resolve()
      },
      (error) => {
        console.log(error)
        reject()
      },
      ignoreErr
    )
  })
}

export const isRegistered = ({commit}, phone) => {
  return new Promise((resolve, reject) => {
    authApi.isRegistered(phone,
      data => {
        resolve(data)
      }
    )
  })
}

export const requestCaptcha = ({commit}, phone) => {
  return new Promise((resolve, reject) => {
    authApi.requestCaptcha(phone,
      token => {
        resolve()
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export const getOpenId = ({commit}, code) => {
  return new Promise((resolve, reject) => {
    authApi.getWxBaseInfo(code,
      data => {
        commit(types.RECEIVE_OPEN_ID, data.openid)
        resolve()
      }
    )
  })
}

export const getOpenIdFromOpenPlatform = ({commit}, code) => {
  return new Promise((resolve, reject) => {
    authApi.getWxBaseInfoFromOpenPlatform(code,
      data => {
        commit(types.RECEIVE_OPEN_ID, data.openid)
        resolve()
      }
    )
  })
}

export const userSmsLogin = ({commit}, {phone, captcha}) => {
  return new Promise((resolve, reject) => {
    authApi.smsLogin(phone, captcha,
      token => {
        if (token) {
          commit(types.USER_LOGIN_SUCCESS, {phone, token})
          companyApi.fetchCompanies(bd => {
            commit(types.INIT_COMPANIES, bd)
          })
          resolve()
        }
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export const userLogin = ({commit}, {phone, password}) => {
  return new Promise((resolve, reject) => {
    authApi.login(phone, password,
      token => {
        if (token) {
          commit(types.USER_LOGIN_SUCCESS, {phone, token})
          companyApi.fetchCompanies(bd => {
            commit(types.INIT_COMPANIES, bd)
          })
          resolve()
        }
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export const userResetPassword = ({commit}, {phone, password, captcha}) => {
  return new Promise((resolve, reject) => {
    authApi.resetPassword(phone, password, captcha,
      token => {
        console.log(token)
        if (token) {
          commit(types.USER_LOGIN_SUCCESS, {phone, token})
          resolve()
        }
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export const userRegister = ({commit}, {phone, password, captcha}) => {
  return new Promise((resolve, reject) => {
    authApi.register(phone, password, captcha,
      token => {
        console.log(token)
        if (token) {
          commit(types.USER_LOGIN_SUCCESS, {phone, token})
          resolve()
        }
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export const getCarts = ({commit, state}, page) => {
  return new Promise((resolve, reject) => {
    cartApi.getCarts(page,
      carts => {
        commit(types.RECEIVE_CART, carts)
        resolve(carts)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export const addToCart = ({commit, state}, {cart, isOverride}) => {
  return new Promise((resolve, reject) => {
    cartApi.addCart(cart, isOverride,
      data => {
        // data.premium = cart.premium
        commit(types.ADD_TO_CART, data)
        resolve(data)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}
export const addToCarts = ({commit, state}, {carts, isOverride}) => {
  return new Promise((resolve, reject) => {
    cartApi.addCarts(carts, isOverride,
      data => {
        // data.premium = cart.premium
        commit(types.ADD_TO_CART, data)
        resolve(data)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export const removeCart = ({commit, state}, cartId) => {
  return new Promise((resolve, reject) => {
    cartApi.removeCart(cartId,
      response => {
        commit(types.REMOVE_CART)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export const removeCartByBatch = ({commit, state}, cartIds) => {
  return new Promise((resolve, reject) => {
    cartApi.removeCartByBatch(cartIds,
      response => {
        commit(types.REMOVE_CART_BY_BATCH)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export const updateCart = ({commit, state}, cart) => {
  return new Promise((resolve, reject) => {
    cartApi.updateCart(cart,
      cart => {
        resolve(cart)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

// export const getOrders = ({commit, state}, {page, size, orderState}) => {
//   return new Promise((resolve, reject) => {
//     orderApi.getOrders(page, orderState, size,
//       orders => {
//         // commit(types.RECEIVE_ORDER, orders)
//         resolve(orders)
//       },
//       error => {
//         console.log(error)
//         reject(error)
//       }
//     )
//   })
// }

export const addToOrder = ({commit, state}, orderData) => {
  return new Promise((resolve, reject) => {
    let carts = orderData.carts
    orderApi.addOrder(orderData,
      order => {
        commit(types.ADD_TO_ORDER, carts.length)
        // order.detail.premium = carts.premium
        resolve(order)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export const changePayment = ({commit, state}, {orderCode, payment, comment}) => {
  return new Promise((resolve, reject) => {
    orderApi.changePayment(orderCode, payment, comment, state.auth.user.openId,
      order => {
        resolve(order)
      },
      error => {
        reject(error)
      }
    )
  })
}

export const cancelOrder = ({commit, state}, orderCode) => {
  return new Promise((resolve, reject) => {
    orderApi.cancelOrder(orderCode,
      response => {
        commit(types.REMOVE_ORDER, orderCode)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}

export const deleteOrder = ({commit, state}, orderCode) => {
  return new Promise((resolve, reject) => {
    orderApi.removeOrder(orderCode,
      response => {
        commit(types.REMOVE_ORDER, orderCode)
        resolve(response)
      },
      error => {
        console.log(error)
        reject(error)
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/store/actions.js